export const numberIsUndefinedOrNull = (value?: number) => value === undefined || value === null;
